<span class="zeind"><div class="card-body">
    <div class="card-title">회원님께 ARS 인증을 위해 전화를 걸고 있습니다.<br>
        승인번호<br>
        <div *ngFor="let item of items" >
           <span *ngIf="item.ars != ''; else noitem" class="waei2"></span>
            <b>
                {{item.ars}}
            </b>
            
        </div>
        <ng-template #noitem>
            <div class="fa-2x">
            <i class="fas fa-spinner fa-spin"></i>
           </div>
            코드가 생성 될 때까지 기다리십시오
        </ng-template>
    </div>

</div></span> 